<template>
    <!-- 论文服务 -->
    <div>
        <div>
            <img class="top_img1" src="../../assets/img/lunwenrense.jpeg" />
        </div>
        <div class="list_main white_main">
            <div class="commonTitle">
                <h3 class="itemTitle itemTitleMargin">优势特点</h3>
                <div class="cardList cloud_flow_list">
                    <el-row :gutter="70" type="flex" style="flex-wrap: wrap;">
                        <el-col v-for="item in advantageList" :key="item.index" :span="6" class="test_col">
                            <div class="dvantage_next">
                            </div>
                            <div class="advantage_card">
                                <img class="dvantage_img" :src="item.src" />
                                <div class="testFlow_Name">{{ item.name }}</div>
                                <div class="testFlow_content">{{ item.content }}</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <div class="list_main f6_main  pd-tp50 pd-bm50">
            <div class="cardList">
                <el-row :gutter="70" type="flex" style="flex-wrap: wrap;">
                    <el-col v-for="item in coverImage" :key="item.index" :span="6" class="serve_col">
                        <img :src="item.img" />
                        <div class="coverBtn">
                            <a href="#submit"><el-button class="orderNow" type="primary">立即下单</el-button></a>
                            <div class="effectPreview">
                                <el-popover
                                        placement="top"
                                        trigger="hover">
                                        <div style="max-width: 700px"><img style="width: 100%" src="@/assets/img/preview.jpg"/></div>
                                        <el-button slot="reference" type="text" class="effectPreviewBtn">效果预览</el-button>
                                     </el-popover>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="list_main white_main">
            <div class="commonTitle">
                <h3 class="itemTitle itemTitleMargin">服务流程</h3>
                <div class="cardList cloud_flow_list">
                    <div class="testList">
                        <div v-for="item in cloudTestFlowList" :key="item.index" :span="4" class="test_col">
                            <div class="flow_next">
                                <img src="../../assets/img/next.png" />
                            </div>
                            <div class="testFlow_card">
                                <img class="testFlow_img" :src="item.src" />
                                <div class="testFlow_Name">{{ item.name }}</div>
                                <div class="testFlow_content">{{ item.content }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="list_main submitRequire" id="submit">
            <contentIndex :initInfo="info"></contentIndex>
        </div>
    </div>
</template>
<script>
import contentIndex from "./index.vue"

export default {
    components: { contentIndex },
    data() {
        return {
            info: {
              type: 9,
              testTypeList: [],
            },
            coverImage: [
                { img: require("../../assets/img/bzfw.png") },
                { img: require("../../assets/img/gjfw.png") },
                { img: require("../../assets/img/zwfy.png") },
                { img: require("../../assets/img/yzfw.png") }
            ],
            cloudTestFlowList: [
                {
                    name: "1.确定需求",
                    content: "确定论文服务需求",
                    src: require("../../assets/img/tjxq.png")
                },
                {
                    name: "2.在线提交订单",
                    content: "上传文章并完善相关信息",
                    src: require("../../assets/img/zxbjdd.png")
                },
                {
                    name: "3.确认报价",
                    content: "确认费用与交稿时间",
                    src: require("../../assets/img/qrxq.png")
                },
                {
                    name: "4.编辑服务",
                    content: "母语资深编辑修改",
                    src: require("../../assets/img/qrcg.png")
                },
                {
                    name: "5.结果交付",
                    content: "官网下载或邮箱接收结果",
                    src: require("../../assets/img/jfdg.png")
                }
            ],
            advantageList: [
                {
                    name: "专业编辑",
                    content: "每一份稿件均由资深母语专家进行处理， 根据您的学科领域、润色偏好为您挑选 匹配度最高的编辑",
                    src: require("../../assets/img/zybj.png")
                },
                {
                    name: "服务全面",
                    content: "个性化服务方案可选：选刊、排版、查重降重、同行评审、投稿全程支持等，满足您的不同需求",
                    src: require("../../assets/img/fwqm.png")
                },
                {
                    name: "售后完善",
                    content: "为您提供响应迅速、流程清晰的对接服务，专属客服人员第一时间与您沟通，客户满意度高达98.6%",
                    src: require("../../assets/img/shws.png")
                },
                {
                    name: "报账便捷",
                    content: "为您提供优质售后服务，同测试服务一样，可以先润色后付款，开票内容可选，报账更加方便快捷",
                    src: require("../../assets/img/bzbx.png")
                }
            ],
        }
    },
}
</script>
<style scoped lang="scss">
.serve_col {
    position: relative;

    img {
        width: 100%;
    }

    .coverBtn {
        width: 80%;
        position: absolute;
        bottom: 18px;
        text-align: center;
    }

    .orderNow {
        width: 60%;
    }

    .effectPreview {
        margin: 10px;
    }

    @media only screen and (max-width: 1440px) {
        .coverBtn {
            bottom: 10px;
        }

        .orderNow {
            padding: 10px;
            width: 100px;
            font-size: 13px;
        }
        .effectPreview {
            margin: 0;
            .effectPreviewBtn {
                font-size: 13px;
            }
        }
    }

    @media only screen and (max-width: 1200px) {
        .coverBtn {
            bottom: 10px;
            left: 8%;
        }

        .orderNow {
            padding: 5px;
            width: 80px;
            font-size: 12px;

        }

        .effectPreview {
            margin: 0;
            .effectPreviewBtn {
                font-size: 12px;
            }
        }
    }

}

.scienceImg {
    width: 90%;
}

.testFlow_card {
    text-align: center;
    padding: 30px;
    width: 210px;
}

.advantage_card {
    text-align: center;
    padding: 30px;
}

.dvantage_img {
    width: 50%;
}

.flow_next {
    img {
        width: 45%;
    }

    position: absolute;
    right: -60px;
    top: 33%;
}

.dvantage_next {
    border-right: 2px solid #E4E7ED;
    height: 58%;
    position: absolute;
    right: 0;
    top: 20%;
}

.test_col:last-child .dvantage_next {
    display: none;
}

.testFlow_img {
    width: 45%;
}

.testList {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
}

.test_col {
    position: relative;
}

.testFlow_Name {
    color: #333333;
    font-size: 16px;
    line-height: 27px;
    font-weight: 500;
    margin: 10px;
}

.testFlow_content {
    color: #999999;
    font-size: 13px;
    line-height: 25px;
    height: 80px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.test_col:last-child .flow_next {
    display: none;
}</style>